import { gql } from '@apollo/client'
import { STORE_REGION_FRAGMENT } from '../fragments'

export const CREATE_REGION = gql`
  mutation CreateRegion($input: CreateRegionInput!) {
    createRegion(input: $input) {
      region {
        ...StoreRegion
      }
    }
  }
  ${STORE_REGION_FRAGMENT}
`
